import { keymirror } from 'utils/keymirror'
import { UpdateStatusDialog } from '../apps/booking/components/StatusUpdates/DialogContent'

export const DIALOGS = keymirror({
  option: null,
  update_status: null,
  cover_load: null,
})

export const dialogOptions = {
  update_status: {
    id: 'update-status',
    header: 'Update Status',
    size: 'small',
    component: UpdateStatusDialog,
  },
  option: {
    id: 'option-flow',
    header: 'Add Option',
    size: 'small',
    component: () => null,
  },
}

export const ceTimeOffDialog = {
  id: 'ce-time-off',
  header: 'Add Time Off',
  size: 'small',
}
